export enum DocumentSelectionCriterion {
  Language = "Language",
  Profession = "Profession",
  Qualification = "Qualification",
  FederalState = "FederalState",
  ImmigrationCountry = "ImmigrationCountry",
  ImmigrationAuthority = "ImmigrationAuthority",
  RecognitionAuthority = "RecognitionAuthority",
  CountryOfOrigin = "CountryOfOrigin",
  DiplomaticMission = "DiplomaticMission",
  CountryOfHabitualResidence = "CountryOfHabitualResidence",
  Employer = "Employer",
  EmployerAfterRecognition = "EmployerAfterRecognition",
  WorkLocation = "WorkLocation",
  WorkLocationAfterRecognition = "WorkLocationAfterRecognition",
  Source = "Source",
  Function = "Function",
  QualificationMeasure = "QualificationMeasure",
  PlacementPartner = "PlacementPartner",
  ChamberOfCrafts = "ChamberOfCrafts",
  RecognitionCenter = "RecognitionCenter",
  TheoryInstitution = "TheoryInstitution",
}

interface Dependency<T> {
  parent: T;
  children: T[];
}

export function getDocumentSelectionDependencies(): Dependency<DocumentSelectionCriterion>[] {
  return [
    {
      parent: DocumentSelectionCriterion.ImmigrationCountry,
      children: [
        DocumentSelectionCriterion.Employer,
        DocumentSelectionCriterion.EmployerAfterRecognition,
        DocumentSelectionCriterion.WorkLocation,
        DocumentSelectionCriterion.WorkLocationAfterRecognition,
        DocumentSelectionCriterion.ImmigrationAuthority,
        DocumentSelectionCriterion.RecognitionAuthority,
        DocumentSelectionCriterion.ChamberOfCrafts,
        DocumentSelectionCriterion.RecognitionCenter,
        DocumentSelectionCriterion.FederalState,
        DocumentSelectionCriterion.DiplomaticMission,
      ],
    },
    {
      parent: DocumentSelectionCriterion.FederalState,
      children: [
        DocumentSelectionCriterion.ImmigrationAuthority,
        DocumentSelectionCriterion.RecognitionAuthority,
        DocumentSelectionCriterion.ChamberOfCrafts,
      ],
    },
    {
      parent: DocumentSelectionCriterion.RecognitionCenter,
      children: [DocumentSelectionCriterion.ChamberOfCrafts],
    },
    {
      parent: DocumentSelectionCriterion.CountryOfOrigin,
      children: [DocumentSelectionCriterion.DiplomaticMission],
    },
  ];
}

export const documentSelectionCriterionToLabelMap: Record<DocumentSelectionCriterion, string | string[]> = {
  Language: "governance.communicationLanguage",
  Profession: "profession",
  Qualification: ["os.profile.qualifications", "qualification"],
  ImmigrationCountry: "immigrationCountry",
  CountryOfOrigin: "os.profile.countryOfOrigin",
  Employer: "migration.de.employmentRelationship.beforeRecognition.employerId",
  EmployerAfterRecognition: "migration.de.employmentRelationship.afterRecognition.employerId",
  WorkLocation: "migration.de.employmentRelationship.beforeRecognition.workLocationOrganizationId",
  WorkLocationAfterRecognition: "migration.de.employmentRelationship.afterRecognition.workLocationOrganizationId",
  ImmigrationAuthority: "migration.de.recognitionPath.current.immigrationAuthority",
  RecognitionAuthority: "migration.de.recognitionPath.current.recognitionAuthority",
  RecognitionCenter: "migration.de.recognitionPath.current.recognitionCenter",
  ChamberOfCrafts: "migration.de.recognitionPath.current.chamberOfCrafts",
  FederalState: "migration.de.recognitionPath.current.federalState",
  DiplomaticMission: "migration.de.visa.diplomaticMissionOfGermanyInCountry",
  CountryOfHabitualResidence: "os.profile.countryOfHabitualResidence",
  Function: "function",
  QualificationMeasure: "migration.de.qualificationMeasure.qualificationMeasure",
  Source: "internal.sourceOrganizationId",
  PlacementPartner: "internal.placementPartnerOrganizationIds",
  TheoryInstitution: "migration.de.qualificationMeasure.theoryInstitution",
};
